var map = {
	"./br/PT/S1/bg115.png": 45260,
	"./br/PT/S2/bg115.png": 83884,
	"./br/PT/bg115.png": 90212,
	"./in/EN/S1/bg115.png": 19824,
	"./in/EN/S2/bg115.png": 70954,
	"./in/EN/bg115.png": 41463,
	"./in/HI/bg115.png": 24267,
	"./mx/EN/S1/bg115.png": 84271,
	"./mx/EN/bg115.png": 8356,
	"./mx/ES/bg115.png": 71840,
	"./ng/EN/S1/bg115.png": 60713,
	"./ng/EN/bg115.png": 91466,
	"./ph/EN/S1/bg115.png": 78875,
	"./ph/EN/bg115.png": 35492,
	"./vn/VI/S1/bg115.png": 82393,
	"./vn/VI/bg115.png": 47428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78427;